export const GET_RECENT_SEARCHES = 'GET_RECENT_SEARCHES';
export const GET_SEARCHES_SUCCESS = 'GET_SEARCHES_SUCCESS';
export const GET_SEARCHES_ERROR = 'GET_SEARCHES_ERROR';
export const GET_SEARCH_PRODUCT = 'GET_SEARCH_PRODUCT';